/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var moment = require('moment');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetActiveApplications: {
        $xmlns: 'http://dobs.pa.gov/nd/application/bpm/1.0'
      }
    },
    blueprintArrays: ['GetActiveApplicationsResponse.ND_Application'],
    blueprint: {
      applications: [
        '$..ND_Application',
        {
          id: '$..ID',
          applicationTypeId: '$..ApplicationTypeID',
          applicationType: '$..ApplicationType',
          nmlsEntityId: '$..NMLSEntityID',
          licenseType: '$..LicenseType',
          applicationStatusId: '$..ApplicationStatusID',
          applicationStatus: '$..ApplicationStatus',
          entityName: '$..EntityName',
          tin: '$..TIN',
          submissionDate: '$..SubmissionDate',
          owner: '$..Owner'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      _.each(response.applications, function(application) {
        application.submissionDate = moment(application.submissionDate, moment.ISO_8601);
        application.licenseType = application.licenseType || '--';
        application.owner = application.owner || '--';
        application.nmlsEntityId = application.nmlsEntityId || '--';
      });

      deferred.resolve(response.applications);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
